import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetUserDefaultFilters } from './get-user-default-filters.service';
import { PostUserDefaultFilters } from './post-user-default-filters.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    GetUserDefaultFilters,
    PostUserDefaultFilters
  ],
})
export class ProfileModule {}
